<template>
  <div>
    <vs-table
      stripe
      :data="items.zones"
      multiple
      v-model="selected"
    >
      <template slot="thead">
        <vs-th>
          Name
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="item.id" :key="item.id" v-for="item in data">
          <vs-td>
            {{item.name}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-3 mb-3" v-if="page">
      <pagination :last-page="items.pagination.pages" v-model="page" />
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";

  export default {
    name: "Zones",
    props: {
      value: {
        type: Array,
        required: true
      }
    },
    data(){
      return {
        page: null,
        search: null,
        items: {
          zones: [],
          pagination: {
            page: 1,
            limit: 10,
            total: 0,
            pages: 0,
            prev: null,
            next: null
          }
        },
        selected: []
      }
    },
    computed: {
      ...mapState(['partner_namespace']),
    },
    watch : {
      page(newVal, oldVal){
        if(newVal !== oldVal){
          this.getItems(this.search);
        }
      },
      selected(newVal, oldVal){
        this.$emit('input', newVal);
      }
    },
    created () {
      this.page = 1;
      this.doSearch = _.debounce(this.getItems,300);
    },
    methods: {
      ...mapActions('zones',['getZones', 'fetchPartnerZones']),
      getItems(search){

        if(this.page > 1 && this.page > this.items.pagination.pages){
          this.page = this.items.pagination.pages;
        }
        let payload = {
          page: this.page
        };
        if(search){
          payload.search = search;
        }
        if(this.partner_namespace){
          payload.partner_id = this.partner_namespace;
          this.fetchPartnerZones(payload)
            .then(data=>{
              this.items = data;
            })
            .catch(error=>{

            })
        }else{
          this.getZones(payload)
            .then(data=>{
              this.items = data;
            })
            .catch(error=>{

            })
        }

      },
      handleSearch(searching){
        this.page = 1;
        this.search = searching === '' ? null : searching;
        this.doSearch(searching);
      },
    }
  }
</script>

<style scoped>

</style>
